import React from 'react';
import {Header, Breadcrumb, Loader, Segment, Tab, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Icon} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import ReporteCurso from './ReporteCurso';
import ReporteExamen from './ReporteExamen';
import ResultadoExamen from './ResultadoExamen';
import HabilitarExamen from './HabilitarExamen';

const ReportePanel=({id, ajaxCallInProgress, cambiarEstatus, errors=[],reporte, strings, cursoCombo, onChange, inscripcion, download, resultadosExamen, downloadExamen, constancia, onShowExamen, onShowAvance, datosResultado,inscripcionCombo, onChangeExamen, onSaveExamen, examenCombo, cambiarEstatusExamen, consultar})=>{


     const panes = [
  {
    menuItem: 'Inscritos',
    render: () => <Tab.Pane attached={false}>
       
                <ReporteCurso
                    cambiarEstatus={cambiarEstatus}
                    reporte={reporte}
                    strings={strings}
                    cursoCombo={cursoCombo} 
                    onChange={onChange} 
                    inscripcion={inscripcion} 
                    download={download}
                    constancia={constancia}
                    resultadosExamen = {resultadosExamen}
                    onShowAvance={onShowAvance}
                />
         </Tab.Pane>
  },
  {
    menuItem: 'Examenes',
    render: () => 
          <div>

          <ReporteExamen
            strings = {strings} 
            resultadosExamen = {resultadosExamen}
            download={downloadExamen}
            onShowExamen={onShowExamen}
            reporte={reporte}
            onChange={onChange} 
         />

         </div>
  },
  {
    menuItem: 'Asignar calificación de examen',
    render: () => 
          <div>
            <ResultadoExamen
            datos={datosResultado}
            inscripcionCombo={inscripcionCombo}
            strings={strings}
            onChange={onChangeExamen}
            onSave={onSaveExamen}
            examenCombo={examenCombo}
            />
          
         </div>
  },{
    menuItem: 'Habilitar examen',
    render: () => <Tab.Pane attached={false}>
                <HabilitarExamen
                    cambiarEstatus={cambiarEstatusExamen}
                    reporte={reporte}
                    strings={strings}
                    cursoCombo={cursoCombo} 
                    onChange={onChange} 
                    inscripcion={inscripcion} 
                    download={download}
                    constancia={constancia}
                    resultadosExamen = {resultadosExamen}
                    onShowAvance={onShowAvance}
                />
         </Tab.Pane>
  }
         
]
 
	return (
        <div >
        
            <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
                <Loader size='big' inline content={strings?strings["Procesando"]:""}/>
            </Dimmer>

            <Header dividing>             
                <Header.Content>{strings?strings["ReporteInscritos"]:""}</Header.Content>
            </Header>

            <Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form >
                              <Form.Field  required  error={errors.cursoId}>
                              <label  >{strings?strings["Curso"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["Curso"]:""} 
                                    name="cursoId"
                                     fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={reporte.cursoId}
                                    options={cursoCombo}/>
                            </Form.Field>
                            <Form.Field  required  error={errors.filtro}>            
                              <label  >{strings?strings["filtro"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["filtro"]:""} 
                                    name="filtro"
                                    onChange={onChange}
                                    value={reporte.filtro}
                                    icon='edit'/>
                            </Form.Field>
                        
                         </Form>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column  textAlign="center">
        
                            <Button.Group  >
               
                            <Button  color="black"
                                onClick={consultar}>{strings?strings["consultar"]:""}
                             </Button>
                            </Button.Group>
            
                    </Grid.Column>
                </Grid.Row>
                
            </Grid>
        
            
        
        
            <br/>
            <br/>    
        
            <div>
            <Tab menu={{ pointing: true }} panes={panes} /> 
            </div>
         
        </div>
	);
};



export default ReportePanel;